import styled from 'styled-components';
import { COLORS, MAX_SCREEN } from '@themes';

export const Style = styled.div<{ $opacity: number }>`
  align-items: center;
  justify-content: center;
  /* padding-top: 20px; */
  min-height: 160px;
  height: 10vw;
  display: flex;
  width: 100%;
  padding-top: 1%;
  position: relative;
  /* background-color: beige; */
  .column-1 {
    height: 100%;
    width: 20%;
    /* min-width: 310px; */
    position: relative;
    /* border: 1px solid red; */
    .system {
      display: flex;
      height: 100%;
      /* margin-left: 4%; */
      .box {
        position: absolute;
        top: -3%;
        height: 100%;
        left: -5%;
      }
      .icon {
        width: 36%;
        margin-top: -4%;
        margin-left: 1%;
      }
      .text {
        margin-left: -5%;
      }
    }
  }
  .column-2 {
    height: 100%;
    width: 40%;
    font-weight: bold;
    font-size: 2vw;
    /* border: 1px solid green; */
    position: relative;
    /* min-width: 490px; */
    .energy {
      display: flex;
      .box {
        position: absolute;
        z-index: 1;
        top: -5.5%;
        height: 107%;
      }
      .icon {
        transition: all 0.8s ease-in-out;
        opacity: ${({ $opacity }) => $opacity};
        position: relative;
        z-index: 2;
        width: 10%;
        margin-top: 6%;
        margin-left: 9%;
        margin-right: 6%;
      }
      .text {
        width: 100%;
        position: relative;
        z-index: 2;
        letter-spacing: 2px;
        left: -1%;
        .total {
          font-size: 1.3vw;
          margin-top: -3%;
          .number {
            letter-spacing: 0px;
            font-weight: bold;
          }
          @media (max-width: ${MAX_SCREEN}px) {
            font-size: 20px;
          }
        }
      }
    }
  }
  .column-3 {
    width: 40%;
    /* border: 1px solid orange; */
    height: 100%;
    position: relative;
    .animation {
      .sun {
        z-index: 2;
        position: absolute;
        top: -20%;
        width: 20%;
        min-width: 65px;
        left: -12%;
        animation: sun 13s linear infinite;

        @keyframes sun {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      }

      .cloud-1 {
        z-index: 3;
        position: absolute;
        width: 60%;
        animation: cloud-1 20s linear infinite;
        top: -10%;
        @keyframes cloud-1 {
          0% {
            left: -15%;
          }
          50% {
            left: 5%;
            opacity: 0;
          }
          100% {
            left: -15%;
            opacity: 0.7;
          }
        }
      }
      .cloud-2 {
        z-index: 3;
        position: absolute;
        width: 40%;
        animation: cloud-2 10s linear infinite;

        @keyframes cloud-2 {
          0% {
            left: -10%;
          }
          50% {
            left: 5%;
            opacity: 0;
          }
          100% {
            left: -10%;
            opacity: 0.7;
          }
        }
      }
    }

    .date {
      display: flex;
      position: absolute;
      top: -28%;
      right: 8%;
      width: 100%;
      /* background-color: yellow; */
      .text {
        font-size: 0.9vw;
        font-weight: bold;
        letter-spacing: 1px;
      }
      .calendar {
        flex: 1;
        .img-calendar {
          width: 11%;
          margin-top: -2.5%;
          float: right;
        }
      }

      .language {
        cursor: pointer;
      }
    }
    .address,
    .temperature {
      margin-top: -2%;
      margin-left: 18%;
      height: 35%;
      /* min-height: 65px; */
      width: 75%;
      /* min-width: 350px; */
      border: 1px solid #8ad0f3;
      border-radius: 20px;
      .pin {
        width: 15%;
        margin-left: 5%;
        top: -8%;
        position: absolute;
      }
      .map {
        .text {
          position: absolute;
          right: 10%;
          top: 5%;
          width: 50%;
        }
      }
    }
    .temperature {
      margin-top: 2%;
      height: 50%;
      /* min-height: 86px; */
      /* min-width: 350px; */
      text-align: center;
      .icon-1,
      .icon-2 {
        width: 38%;
        position: relative;
        left: 15%;
        top: -5%;
      }
      .icon-2 {
        left: 0%;
      }
      .circle {
        border-radius: 50%;
        width: 3.5%;
        height: 10%;
        margin-top: 7%;
        color: ${COLORS.BLACK_1};
        border: 2px solid;
      }
    }
  }
`;
